export default __webpack_public_path__ + "static/media/Hero-SVG3.f20c73f5.svg";